import {
  getVideoRequests,
  getVideoRequest,
  updateVideoRequest,
  getVideoRequestsCount,
  approveVideoRequest,
  denyVideoRequest,
} from 'lib/api';
import { VIDEO_REQUESTS_ACTIONS } from './videoRequestReducer';
import {
  VideoRequestQueryParams,
  GetVideoRequestParams,
  UpdateVideoRequestParams,
  ApproveDenyVideoRequestParams,
  VideoRequestCountQueryParams,
} from '.';
import { VideoStatus } from 'lib/const';

const {
  GET_PENDING_VIDEO_REQUESTS_COUNT_START,
  GET_PENDING_VIDEO_REQUESTS_COUNT_ERROR,
  GET_PENDING_VIDEO_REQUESTS_COUNT_SUCCESS,
  GET_PENDING_VIDEO_REQUESTS_START,
  GET_PENDING_VIDEO_REQUESTS_ERROR,
  GET_PENDING_VIDEO_REQUESTS_SUCCESS,
  GET_PAST_VIDEO_REQUESTS_START,
  GET_PAST_VIDEO_REQUESTS_ERROR,
  GET_PAST_VIDEO_REQUESTS_SUCCESS,
  GET_VIDEO_REQUEST_START,
  GET_VIDEO_REQUEST_ERROR,
  GET_VIDEO_REQUEST_SUCCESS,
  EDIT_VIDEO_REQUEST_START,
  EDIT_VIDEO_REQUEST_ERROR,
  EDIT_VIDEO_REQUEST_SUCCESS,
} = VIDEO_REQUESTS_ACTIONS;

export const loadVideoRequestsCountPending = async ({
  dispatch,
}: VideoRequestCountQueryParams): Promise<void> => {
  dispatch({ type: GET_PENDING_VIDEO_REQUESTS_COUNT_START });

  const response = await getVideoRequestsCount(`${VideoStatus.Pending}`).catch(
    err => err
  );
  if (response instanceof Error) {
    dispatch({
      type: GET_PENDING_VIDEO_REQUESTS_COUNT_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_PENDING_VIDEO_REQUESTS_COUNT_SUCCESS,
    payload: {
      count: response.count,
    },
  });
};

export const loadVideoRequests = async ({
  dispatch,
  filter,
  start,
  limit,
}: VideoRequestQueryParams): Promise<void> => {
  dispatch({ type: GET_PAST_VIDEO_REQUESTS_START });

  const response = await getVideoRequests({ filter, start, limit }).catch(
    err => err
  );
  if (response instanceof Error) {
    dispatch({
      type: GET_PAST_VIDEO_REQUESTS_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_PAST_VIDEO_REQUESTS_SUCCESS,
    payload: {
      videoRequests: response.videoRequests,
      count: response.count,
    },
  });
};

export const loadVideoRequestsPending = async ({
  dispatch,
  filter,
  start,
  limit,
}: VideoRequestQueryParams): Promise<void> => {
  dispatch({ type: GET_PENDING_VIDEO_REQUESTS_START });

  const response = await getVideoRequests({ filter, start, limit }).catch(
    err => err
  );
  if (response instanceof Error) {
    dispatch({
      type: GET_PENDING_VIDEO_REQUESTS_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_PENDING_VIDEO_REQUESTS_SUCCESS,
    payload: {
      videoRequests: response.videoRequests,
      count: response.count,
    },
  });
};

export const loadVideoRequest = async ({
  videoRequestId,
  dispatch,
}: GetVideoRequestParams): Promise<void> => {
  dispatch({ type: GET_VIDEO_REQUEST_START });

  const response = await getVideoRequest(videoRequestId).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_VIDEO_REQUEST_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_VIDEO_REQUEST_SUCCESS,
    payload: {
      videoRequest: response,
    },
  });
};

export const editVideoRequest = async (
  params: UpdateVideoRequestParams
): Promise<any> => {
  const { data, dispatch, videoRequestId } = params;
  dispatch({ type: EDIT_VIDEO_REQUEST_START });
  const videoRequest = await updateVideoRequest({
    videoRequestId,
    data,
  }).catch(err => err);
  if (videoRequest instanceof Error) {
    dispatch({
      type: EDIT_VIDEO_REQUEST_ERROR,
      error: videoRequest.message,
    });
    return {};
  }
  dispatch({
    type: EDIT_VIDEO_REQUEST_SUCCESS,
    payload: {
      videoRequestId,
      videoRequest,
    },
  });
  return videoRequest;
};

export const editVideoRequestApprove = async (
  params: ApproveDenyVideoRequestParams
): Promise<object> => {
  const { dispatch, videoRequestId } = params;
  dispatch({ type: EDIT_VIDEO_REQUEST_START });
  const videoRequest = await approveVideoRequest({
    videoRequestId,
  }).catch(err => err);
  if (videoRequest instanceof Error) {
    dispatch({
      type: EDIT_VIDEO_REQUEST_ERROR,
      error: videoRequest.message,
    });
    return {};
  }
  dispatch({
    type: EDIT_VIDEO_REQUEST_SUCCESS,
    payload: {
      videoRequestId,
      videoRequest,
    },
  });
  return videoRequest;
};

export const editVideoRequestDeny = async (
  params: ApproveDenyVideoRequestParams
): Promise<object> => {
  const { dispatch, videoRequestId, note } = params;
  dispatch({ type: EDIT_VIDEO_REQUEST_START });
  const videoRequest = await denyVideoRequest({
    videoRequestId,
    note,
  }).catch(err => err);
  if (videoRequest instanceof Error) {
    dispatch({
      type: EDIT_VIDEO_REQUEST_ERROR,
      error: videoRequest.message,
    });
    return {};
  }
  dispatch({
    type: EDIT_VIDEO_REQUEST_SUCCESS,
    payload: {
      videoRequestId,
      videoRequest,
    },
  });
  return videoRequest;
};
